module.exports = __webpack_public_path__ + "img/edgardo-suarez.3f61f61b.jpg";